import { ConfirmDialog, Input, Text } from "@aurem/ui";
import { useI18n } from "providers/I18nProvider";
import { useEffect, useState } from "react";

export const ResetNodeConfirmDialog = ({
  open,
  onOpenChange,
  nodeId,
  nodeType,
  sideEffectCount,
  onConfirm,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  nodeId: string;
  nodeType: string;
  sideEffectCount: number;
  onConfirm: () => Promise<void> | void;
}) => {
  const { t } = useI18n();
  const [typedNodeId, setTypedNodeId] = useState("");

  useEffect(() => {
    if (!open) setTypedNodeId("");
  }, [open]);

  const warning =
    sideEffectCount === 0
      ? null
      : nodeType === "payment"
        ? t(
            "apps.admin.internalResources.workflowRun.detail.resetNodePaymentWarning",
            sideEffectCount,
          )
        : nodeType === "market-order"
          ? t(
              "apps.admin.internalResources.workflowRun.detail.resetNodeMarketOrderWarning",
              sideEffectCount,
            )
          : null;

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      variant="danger"
      title={t(
        "apps.admin.internalResources.workflowRun.detail.resetNodeConfirmTitle",
      )}
      description={
        <div className="flex flex-col gap-3">
          <Text size="sm">
            {t(
              "apps.admin.internalResources.workflowRun.detail.resetNodeConfirmDescription",
              nodeId,
            )}
          </Text>
          {warning && (
            <Text size="sm" weight="medium" className="text-danger-600">
              {warning}
            </Text>
          )}
          <Input
            size="sm"
            value={typedNodeId}
            onChange={setTypedNodeId}
            autoComplete="off"
            spellCheck={false}
            placeholder={nodeId}
            aria-label={t(
              "apps.admin.internalResources.workflowRun.detail.resetNodeConfirmPrompt",
              nodeId,
            )}
            data-e2e-id="resetNode__input__nodeId"
          />
          <Text size="xs" className="text-neutral-400">
            {t(
              "apps.admin.internalResources.workflowRun.detail.resetNodeConfirmPrompt",
              nodeId,
            )}
          </Text>
        </div>
      }
      submitText={t(
        "apps.admin.internalResources.workflowRun.detail.resetNodeSubmit",
      )}
      submitButtonProps={{ disabled: typedNodeId.trim() !== nodeId }}
      submitAction={onConfirm}
    />
  );
};
